/* eslint no-shadow: ["error", { "allow": ["state"] }] */
export const namespaced = true;

export const state = {
  editingModules: [],
  syncingWithETapestry: false,
  searchEntityType: 'Instrument',
};

export const actions = {
  async startEditMode({ commit }, entityNamespace) {
    commit('START_EDITING_MODULE', entityNamespace);
  },
  async stopEditMode({ commit }, { entityNamespace }) {
    commit('STOP_EDITING_MODULE', entityNamespace);
  },
  async resetAllEditingModes({ commit }) {
    commit('CLEAR_ALL_EDITING_MODES');
  },
  async startETapestrySync({ commit }) {
    commit('UPDATE_ETAPESTRY_SYNC', true);
  },
  async stopETapestrySync({ commit }) {
    commit('UPDATE_ETAPESTRY_SYNC', false);
  },
  async changeAdvancedSearchEntityType({ commit }, entityType) {
    commit('CHANGE_ADVANCED_SEARCH_ENTITY_TYPE', entityType);
  },
};

export const mutations = {
  START_EDITING_MODULE(state, entityNamespace) {
    state.editingModules.push(entityNamespace);
  },
  STOP_EDITING_MODULE(state, entityNamespace) {
    state.editingModules.splice(state.editingModules.indexOf(entityNamespace), 1);
  },
  CLEAR_ALL_EDITING_MODES(state) {
    state.editingModules.splice(0, state.editingModules.length);
  },
  UPDATE_ETAPESTRY_SYNC(state, value) {
    state.syncingWithETapestry = value;
  },
  CHANGE_ADVANCED_SEARCH_ENTITY_TYPE(state, value) {
    state.searchEntityType = value;
  },
};
